import { render, staticRenderFns } from "./addIntegralRuleConfig.vue?vue&type=template&id=1dfcced8"
import script from "./addIntegralRuleConfig.vue?vue&type=script&lang=js"
export * from "./addIntegralRuleConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports